<header></header>
<category-component></category-component>
<div class="grey-color fixed-header-height side-space-wrapper static-pages no-result-wrapper">
    <div class="container-fluid">
        <!-- No result found -->
        <div class="row no-result">
            <div class="col-12">
                <div class="no-result-content">
                    <img src="../../assets/images/page-not-found.svg" alt="page-not-found">
                    <p>Page Not Found</p>
                    <span>The page you’re looking for doesn’t exists. </span>
                    <a href="/" class="btn primary-btn">Back to Home</a>
                </div>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
<footer></footer>